import styled from '@emotion/styled';
import React, { memo } from 'react';
import { MarketingImage } from '../../../../components/MarketingPagesShared/MarketingImage';
import { BREAKPOINT_SMALL } from '../../../../components/MarketingPagesShared/styles';
import {
  FeaturesCaptionedImage,
  FeaturesSection,
  FeaturesSectionDescription,
  FeaturesSectionSubtitle,
  FeaturesSectionTitle,
  FeaturesCaption,
} from '../../styles';

function FeaturesHostingSectionView() {
  return (
    <FeaturesSection>
      <FeaturesSectionTitle>
        Unlimited, easy hosting and distribution
      </FeaturesSectionTitle>
      <FeaturesHostingGrid>
        <FeaturesCaptionedImage>
          <MarketingImage
            alt="A woman on her laptop with a cloud icon on top of the image"
            imagePath="features/hosting-free-unlimited"
            width={475}
            height={475}
          />
          <FeaturesCaption>
            <FeaturesSectionSubtitle>
              Free, unlimited hosting
            </FeaturesSectionSubtitle>
            <FeaturesSectionDescription>
              You own the rights to all of your content and can host unlimited
              episodes for free, always.
            </FeaturesSectionDescription>
          </FeaturesCaption>
        </FeaturesCaptionedImage>
        <FeaturesCaptionedImage>
          <MarketingImage
            alt="A photo of a busy street from above, with the Spotify, Pocket Casts and Overcast app icons on top of the image"
            imagePath="features/hosting-automatic-distribution"
            width={475}
            height={475}
          />
          <FeaturesCaption>
            <FeaturesSectionSubtitle>
              Automatic distribution to all major listening apps
            </FeaturesSectionSubtitle>
            <FeaturesSectionDescription>
              Reach a wider audience instantly with one-step distribution. Or,
              manage your RSS feed and distribute your podcast yourself.
            </FeaturesSectionDescription>
          </FeaturesCaption>
        </FeaturesCaptionedImage>
      </FeaturesHostingGrid>
    </FeaturesSection>
  );
}

export const FeaturesHostingSection = memo(FeaturesHostingSectionView);

const FeaturesHostingGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
`;
